module.exports = __webpack_public_path__ + "static/media/025-comment.b49985a4.svg";